import { useQuery } from "@tanstack/react-query";
import { queryService } from "../services/query-service";
import {
  OrderGroupResponse,
  OrderListParams,
  OrderListResponse,
} from "../models/api-types";

/**
 * Hook to fetch orders list
 * @param params - Pagination parameters (page, limit)
 */
export const useOrders = (params?: OrderListParams) => {
  return useQuery<OrderListResponse>({
    queryKey: ["orders", params],
    queryFn: () => queryService.getOrders(params),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: 2, // Retry 2 times on error
  });
};

/**
 * Hook to fetch order group by orderGroupId
 * @param orderGroupId - Order group ID
 */
export const useOrderGroup = (orderGroupId: string | null) => {
  return useQuery<OrderGroupResponse>({
    queryKey: ["order-group", orderGroupId],
    queryFn: () => {
      if (!orderGroupId) {
        throw new Error("Order group ID is required");
      }
      return queryService.getOrderGroup(orderGroupId);
    },
    enabled: !!orderGroupId, // Only run query if orderGroupId exists
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: 2, // Retry 2 times on error
  });
};

